import React, { Component } from 'react';
import './App.css';
import logo from './images/2018-banner-logo.jpg';
import customchannels from './images/customchannels.png';
import IcecastNowPlaying from './IcecastNowPlaying';

const default_album_art = 'https://albumart.customchannels.rocks/default-album-art.png';

class App extends Component {

  constructor(){
    super();

    this.state = {
      nowplaying: {
        title: "Title",
        artist: 'Artist',
        album: "Album",
        album_art: { large: default_album_art }},
      tracks: []
    };
  }

  setTrackData(data){
    let tracks = data.data.slice();
    let nowplaying = tracks[0];
    tracks.shift();

    this.setState({
      nowplaying: nowplaying,
      tracks: tracks
    });
  }

  componentWillMount(){
    // get the now playing
    const nowplaying = new IcecastNowPlaying(366, 'http://ccice-adswizz.streamguys.com/30a_128.mp3');
    nowplaying.checkIcecast((data) => {
      this.setTrackData(data);
    });

    setInterval(() => {
      nowplaying.checkIcecast((data) => {
        this.setTrackData(data);
      })
    }, 15000);
  }

  render() {
    return (
      <div className="App">
        <div className="header">
          <div className="image-container">
            <a rel="noopener noreferrer" href="https://30a.com/" target="_blank"><img src={ logo } alt="30A Radio Logo" /></a>
          </div>
        </div>
        <div className="container">
        <a href="https://www.customchannels.net" rel="noopener noreferrer" target="_blank"><img className="img-responsive PoweredBy" src={ customchannels } alt="Powered by Custom Channels" /></a>
          <h1>Thanks for the Memories!</h1>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js